module.exports = __webpack_public_path__ + "static/customize-d56b4e8db819348412459e0dd06d12ed.svg";